import { useEffect, useRef } from 'react'

const useIntersect = (
  handleIntersect: (
    entry: IntersectionObserverEntry,
    observer: IntersectionObserver,
  ) => void,
  deps: any[] = [],
) => {
  const target = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let observer: any

    if (target.current) {
      observer = new IntersectionObserver(_handleIntersect, { threshold: 1 })
      observer.observe(target.current)
    }
    return () => {
      observer && observer.disconnect()
    }
  }, [...deps])

  // TODO eslint 에러 원인 찾기
  // eslint-disable-next-line no-undef
  const _handleIntersect: IntersectionObserverCallback = (
    [entry],
    observer,
  ) => {
    if (entry.isIntersecting) {
      handleIntersect(entry, observer)
    }
  }
  return target
}

export default useIntersect
